import * as React from "react";
import {observer} from "mobx-react";
import { withTranslation, WithTranslation } from "react-i18next";
import {
  Table,
  TableBody,
  TableCell,
  TableHead, TableHeadCell,
  TableHeadRow,
  TableRow,
} from "../../../../libs/components/libs/table/simple";
import {DishOptionSetList} from "../../../../libs/components/libs/elements/dish.option-set-list";
import {DishIngredientsList} from "../../../../libs/components/libs/elements/dish.ingredients-list";
import {DishComboChoiceList} from "../../../../libs/components/libs/elements/dish.combo-list";
import Big from "big.js";

interface Props extends WithTranslation {
  items: OrderDish[];
  itemContent?: (dish: OrderDish, index: number) => React.ReactNode;
  renderDetails?: RestaurantPrinter["receipt"]["dishes"];
}
interface Injected extends Props {}
interface State {}

@observer
class OrderItemsClass extends React.Component<Props, State> {

  render() {
    const { t } = this.props as Injected;
    const { items, itemContent } = this.props;
    const details: RestaurantPrinter["receipt"]["dishes"] = this.props.renderDetails || {
      enabled: true,
      prices: true,
      option_prices: true,
      combo_choice_names: true,
      disable_print_name: true,
    };
    if (!details.enabled) {
      return null;
    }
    return (
      <Table>

        <TableHead>
          <TableHeadRow>
            <TableHeadCell className="cart-items-head-qty" style={{ width: "40px" }}>{t("order.receipt.dishes.headings.quantity")}</TableHeadCell>
            <TableHeadCell className="text-left">{t("order.receipt.dishes.headings.item")}</TableHeadCell>
            {details.prices && <TableHeadCell className="cart-items-head-price" style={{ width: "80px" }}>{t("order.receipt.dishes.headings.price")}</TableHeadCell>}
          </TableHeadRow>
        </TableHead>

        <TableBody>
          {items.map((dish, i) => (
            <TableRow key={i}>

              <TableCell>
                <p>{dish.qty}</p>
              </TableCell>

              <TableCell className="text-left">

                <p>{details.disable_print_name ? (dish.display_name || dish.name) : (dish.print_name || dish.display_name || dish.name)}</p>
                {dish.subtitle && <p className="small lh14">{dish.subtitle}</p>}
                {dish.type !== "combo" && (
                  <div>
                    {(dish.option_sets || []).length > 0 && (
                      <div className="m-t-1">
                        <DishOptionSetList
                          option_sets={dish.option_sets}
                          renderDetails={details}
                        />
                      </div>
                    )}
                    {(dish.ingredients || []).length > 0 && (
                      <div className="m-t-1">
                        <DishIngredientsList ingredients={dish.ingredients}/>
                      </div>
                    )}
                  </div>
                )}

                {dish.type === "combo" && (
                  <div className="m-t-1">
                    <DishComboChoiceList
                      choices={dish.choices}
                      renderDetails={details}
                    />
                  </div>
                )}

                {dish.notes && <p className="m-t-1 small">{t("order.receipt.dishes.notes")}: {dish.notes}</p>}

                {itemContent && itemContent(dish, i)}

              </TableCell>

              {details.prices && (
                <TableCell>
                  {(typeof dish.discount === "number" && dish.discount > 0) && (
                    <>
                      <p className="small"><s>{t("currency", { value: dish.price })}</s></p>
                      <p>{t("currency", { value: Big(dish.price).minus(dish.discount).toFixed(2) })}</p>
                    </>
                  )}
                  {(typeof dish.discount === "undefined") && (
                    <p>{t("currency", { value: dish.price })}</p>
                  )}
                </TableCell>
              )}

            </TableRow>
          ))}
        </TableBody>

      </Table>
    );
  }

}

export const OrderItems = withTranslation()(OrderItemsClass);
